import React from 'react';

export const formatTextWithLinks = (text, post = 0) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const lines = text.split('\n'); // rozdělení podle řádků

    const knownMentions = window.mentionList || [];
    const mentionMap = knownMentions.reduce((map, name) => {
        map[name.toLowerCase()] = name;
        return map;
    }, {});

    // Zpracuj každý řádek samostatně
    const processedLines = lines.map((line, lineIndex) => {
        const parts = line.split(urlRegex);
        const elements = parts.map((part, i) => {
            if (!urlRegex.test(part)) {
                // Zpracování @označení
                const mentionRegex = /@(\w+)/g;
                const segments = [];
                let lastIndex = 0;
                let match;

                while ((match = mentionRegex.exec(part)) !== null) {
                    const start = match.index;
                    const end = mentionRegex.lastIndex;
                    const username = match[1];
                    const lower = username.toLowerCase();

                    if (start > lastIndex) {
                        segments.push(part.slice(lastIndex, start));
                    }

                    if (mentionMap[lower]) {
                        const realName = mentionMap[lower];
                        segments.push(
                            <a
                                key={`mention-${lineIndex}-${i}-${start}`}
                                href={`/profile/${realName}`}
                                className="mention-link text-info"
                            >
                                @{realName}
                            </a>
                        );
                    } else {
                        segments.push(`@${username}`);
                    }

                    lastIndex = end;
                }

                if (lastIndex < part.length) {
                    segments.push(part.slice(lastIndex));
                }

                return <React.Fragment key={`text-${lineIndex}-${i}`}>{segments}</React.Fragment>;
            }

            // Spotify Embed
            if (post === 1 && part.includes("open.spotify.com")) {
                const embedUrl = part.replace("/track/", "/embed/track/");
                return (
                    <div key={`spotify-${lineIndex}-${i}`} className="my-2">
                        <iframe
                            src={embedUrl}
                            height="80"
                            frameBorder="0"
                            allow="encrypted-media"
                            allowFullScreen
                            title="Spotify Embed"
                            style={{ borderRadius: '8px' }}
                        />
                    </div>
                );
            }

            // YouTube Embed
            if (post === 1 && (part.includes("youtube.com/watch?v=") || part.includes("youtu.be/"))) {
                let videoId = "";

                try {
                    if (part.includes("watch?v=")) {
                        videoId = new URL(part).searchParams.get("v");
                    } else if (part.includes("youtu.be/")) {
                        videoId = part.split("youtu.be/")[1];
                    }
                } catch (e) {
                    // fallback
                }

                if (videoId) {
                    return (
                        <div key={`yt-${lineIndex}-${i}`} className="my-2">
                            <iframe
                                width="100%"
                                height="315"
                                src={`https://www.youtube.com/embed/${videoId}`}
                                title="YouTube video"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                style={{ borderRadius: '8px' }}
                            ></iframe>
                        </div>
                    );
                }
            }

            // Obyčejný odkaz
            return (
                <a key={`link-${lineIndex}-${i}`} href={part} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-word' }}>
                    {part}
                </a>
            );
        });

        // Po každém řádku přidáme <br />
        return (
            <React.Fragment key={`line-${lineIndex}`}>
                {elements}
                {lineIndex < lines.length - 1 && <br />}
            </React.Fragment>
        );
    });

    return processedLines;
};
